$.fn.select2.defaults.set('minimumResultsForSearch', 5);
$.fn.select2.defaults.set('dropdownParent', $('.jjk-webinnovations-container'));
